import {
  NestedQuota,
  QuotaPayload,
} from '../../../shared/interfaces/quota.interface';
import { NestedQuotaBuilder } from '../../domain/nested-quota-builder';
import { EachNestingGroupData } from '../interfaces/multi-quota-nesting.interface';
import { NestedQuotaGroupBuilder } from './nested-quota-group-builder';
import { NestedQuotaGroupSeparator } from './nested-quota-group-separator';

export class NestedQuotaResetter {
  constructor(
    private readonly _selectedNestingGroup: EachNestingGroupData,
    private readonly _originalQuotas: QuotaPayload[] = [],
    private readonly _surveyAllocation: number
  ) {}

  public reset(): NestedQuota[] {
    return [...this._rebuiltGrouped(), ...this._rebuiltUngrouped()];
  }

  private _existingGrouped(): NestedQuota[] {
    return this._selectedNestingGroup.quotas.filter(
      (quota) => !!quota.individual_quotas?.length
    );
  }

  private _rebuilt(): NestedQuota[] {
    return new NestedQuotaBuilder(
      this._originalQuotas,
      this._selectedNestingGroup.selectedQualifications,
      this._surveyAllocation,
      this._selectedNestingGroup.id
    ).build();
  }

  private _rebuiltUngrouped(): NestedQuota[] {
    return this._rebuilt().filter(
      (nestedQuota) =>
        !this._existingGrouped().some((g) =>
          g.individual_quotas?.some((iq) =>
            iq.combinedKey?.every((iqKey) =>
              nestedQuota.combinedKey?.includes(iqKey)
            )
          )
        )
    );
  }

  private _rebuiltGrouped(): NestedQuota[] {
    return this._existingGrouped().map((grouped) => {
      const replacedUngroupedQuotas = this._replacedUngroupedQuotas(grouped);
      return {
        ...new NestedQuotaGroupBuilder(
          replacedUngroupedQuotas,
          this._selectedNestingGroup.selectedQualifications,
          [],
          this._selectedNestingGroup.id
        ).build(),
        quota_title: grouped.quota_title,
      };
    });
  }

  private _replacedUngroupedQuotas(groupedQuota: NestedQuota): NestedQuota[] {
    const ungroupedQuotas = new NestedQuotaGroupSeparator(
      groupedQuota
    ).ungroup();
    return ungroupedQuotas
      .map((ungroupedQuota) => {
        return this._rebuilt().find((nq) =>
          nq.combinedKey?.every((nqKey) =>
            ungroupedQuota.combinedKey?.includes(nqKey)
          )
        );
      })
      .filter((nq): nq is NestedQuota => !!nq);
  }
}
